import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaQuestionCircle, FaRobot } from 'react-icons/fa';

const FAQChatSection = () => {
  const { t, i18n } = useTranslation();
  const [activeQuestion, setActiveQuestion] = useState(null);
  const currentLanguage = i18n.language;
  const isRTL = currentLanguage === 'ar';
  
  // Questions et réponses directement depuis les traductions
  const faqData = [
    {
      id: 1,
      question: t('home.faq.questions.q0'),
      answer: t('home.faq.answers.a0')
    },
    {
      id: 2,
      question: t('home.faq.questions.q1'),
      answer: t('home.faq.answers.a1')
    },
    {
      id: 3,
      question: t('home.faq.questions.q2'),
      answer: t('home.faq.answers.a2')
    },
    {
      id: 4,
      question: t('home.faq.questions.q3'),
      answer: t('home.faq.answers.a3')
    },
    {
      id: 5,
      question: t('home.faq.questions.q4'),
      answer: t('home.faq.answers.a4')
    },
    {
      id: 6,
      question: t('home.faq.questions.q5'),
      answer: t('home.faq.answers.a5')
    },
    {
      id: 7,
      question: t('home.faq.questions.q6'),
      answer: t('home.faq.answers.a6')
    },
    {
      id: 8,
      question: t('home.faq.questions.q7'),
      answer: t('home.faq.answers.a7')
    },
    {
      id: 9,
      question: t('home.faq.questions.q8'),
      answer: t('home.faq.answers.a8')
    }
  ];

  // Fonction pour gérer le clic sur une question
  const handleQuestionClick = (id) => {
    setActiveQuestion(id === activeQuestion ? null : id);
  };
  
  return (
    <section className="faq-chat-section" id="faq-chat-section" style={{ padding: '40px 0', direction: isRTL ? 'rtl' : 'ltr' }}>
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
        <div className="section-header" style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <FaQuestionCircle style={{ fontSize: '3.5rem', color: '#0f4c81' }} />
          </div>
          <h2 style={{ fontSize: '2.2rem', marginBottom: '15px', color: '#333' }}>
            {t('home.faq.title')}
          </h2>
          <p style={{ fontSize: '1.1rem', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
            {t('home.faq.description')}
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div style={{ 
            backgroundColor: 'white', 
            borderRadius: '12px', 
            boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
            overflow: 'hidden'
          }}>
            <div style={{ 
              backgroundColor: '#0f4c81', 
              color: 'white', 
              padding: '18px 20px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <FaRobot style={{ fontSize: '1.6rem' }} />
              <h3 style={{ margin: 0, fontSize: '1.4rem', fontWeight: '500' }}>
                {t('home.faq.chatTitle')}
              </h3>
            </div>
            
            <div style={{ padding: '25px' }}>
              <div style={{ marginBottom: '25px', padding: '18px', backgroundColor: '#e6f3ff', borderRadius: '10px', border: '1px solid #cce5ff' }}>
                <p style={{ margin: 0, color: '#0f4c81', fontSize: '1.05rem', textAlign: isRTL ? 'right' : 'left' }}>
                  {t('home.faq.chatWelcome')}
                </p>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {faqData.map((item) => (
                  <div key={item.id} style={{ marginBottom: '15px' }}>
                    <button
                      onClick={() => handleQuestionClick(item.id)}
                      style={{
                        width: '100%',
                        textAlign: isRTL ? 'right' : 'left',
                        padding: '14px 16px',
                        backgroundColor: activeQuestion === item.id ? '#0f4c81' : '#f5f5f5',
                        color: activeQuestion === item.id ? 'white' : '#333',
                        border: '1px solid #ddd',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        fontSize: '1.05rem',
                        fontWeight: activeQuestion === item.id ? 'bold' : 'normal',
                        transition: 'all 0.3s ease',
                        marginBottom: activeQuestion === item.id ? '10px' : '0',
                        boxShadow: activeQuestion === item.id ? '0 4px 8px rgba(0,0,0,0.1)' : 'none'
                      }}
                    >
                      {item.question}
                    </button>
                    
                    {activeQuestion === item.id && (
                      <div style={{ 
                        backgroundColor: 'white',
                        border: '1px solid #e0e0e0',
                        borderRadius: '10px',
                        padding: '16px 18px',
                        marginTop: '10px',
                        boxShadow: '0 3px 8px rgba(0,0,0,0.05)',
                        lineHeight: '1.5',
                        color: '#444',
                        textAlign: isRTL ? 'right' : 'left'
                      }}>
                        {item.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQChatSection;
